import { render, staticRenderFns } from "./myGsDetails.vue?vue&type=template&id=3be9231b&scoped=true&"
import script from "./myGsDetails.vue?vue&type=script&lang=js&"
export * from "./myGsDetails.vue?vue&type=script&lang=js&"
import style0 from "./myGsDetails.vue?vue&type=style&index=0&id=3be9231b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be9231b",
  null
  
)

export default component.exports